import { Box, HStack, Text } from '@chakra-ui/react'

const MAX_SEGMENTS = 12

/** [P5-5] "about N left" from the longest remaining path. Segmented up to 12 steps, else one bar. */
export function ConversationProgress({ done, left }: { done: number; left: number }) {
  const total = done + left
  return (
    <HStack px={4} pt={3} gap={3}>
      <Box flex={1} role="progressbar" aria-label="Conversation progress" aria-valuemin={0} aria-valuemax={total} aria-valuenow={done}>
        {total > 0 && total <= MAX_SEGMENTS ? (
          <HStack gap={1}>
            {Array.from({ length: total }, (_, i) => (
              <Box key={i} data-testid="progress-segment" flex={1} h="6px" borderRadius="full" bg={i < done ? 'accent' : 'border'} />
            ))}
          </HStack>
        ) : (
          <Box h="6px" borderRadius="full" bg="border">
            <Box h="100%" borderRadius="full" bg="accent" w={`${total > 0 ? Math.round((done / total) * 100) : 100}%`} />
          </Box>
        )}
      </Box>
      <Text fontSize="sm" color="fg.muted" flexShrink={0}>{left === 0 ? 'Done' : `about ${left} left`}</Text>
    </HStack>
  )
}
